<script setup lang="ts">
import { computed } from 'vue';

import { useRoute } from 'vue-router';

import { QuestionCircleIcon } from '@thehotelsnetwork/icons/vue/linear';
import { useUserTracking } from '@thehotelsnetwork/vue-user-tracking';

import { navigateToHc } from '@/utils';
import { NavigationTrackingEvent } from '@/modules/UserTracking/trackingEvents';

const route = useRoute();
const { addAction } = useUserTracking();

const isAccountsSettingsPage = computed(() => !!route.meta?.accountSettingsPage);

function onClick() {
  addAction(NavigationTrackingEvent.HelpcenterClick);
  if (isAccountsSettingsPage.value) {
    navigateToHc('accountSettings');
  } else {
    navigateToHc('main');
  }
}
</script>

<template>
  <LpButton
    data-testid="help-btn"
    mode="transparent"
    size="small"
    color="gray"
    tag="a"
    @click="onClick"
  >
    <div class="flex text-base font-normal flex-row items-center capitalize">
      <QuestionCircleIcon class="w-5 h-5 mr-2" />
      {{ $t('help center') }}
    </div>
  </LpButton>
</template>
